// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CiNU","name":"styles_name__3UrTl","phone":"styles_phone__1IaZ6"};